export default {
  schema: {
    type: 'object',
    required: ['requiredRadioQuestion'],
    properties: {
      radioQuestion: {
        title: 'Radio Question',
        type: 'string',
        enum: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6'],
        enumNames: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6']
      },
      requiredRadioQuestion: {
        title: 'Required Radio Question',
        type: 'string',
        enum: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6'],
        enumNames: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6']
      }
    }
  },
  uiSchema: {
    radioQuestion: {
      'ui:widget': 'radio'
    },
    requiredRadioQuestion: {
      'ui:widget': 'radio'
    },
    'dm:layout': [{
      type: 'field',
      id: 'radioQuestion'
    }, {
      type: 'field',
      id: 'requiredRadioQuestion'
    }]
  },
  formData: {}
};